import Checkmark from "@/components/icons/Checkmark";
import Button from "@/components/ui/Button";
import { ISortOption, ISortOrderValue } from "@/lib/types/centra";
import clsx from "clsx";
import React, { Dispatch, SetStateAction } from "react";
import styles from "../index.module.css";

type Props = {
  sortOrder: {
    setSortOrder: Dispatch<SetStateAction<ISortOrderValue[]>>;
    options: ISortOption[];
    active: ISortOption | undefined;
  };
};

const SortModalContent = ({ sortOrder }: Props) => {
  return (
    <div className={styles.sortOptions}>
      {sortOrder.options.map((option) => {
        return (
          <React.Fragment key={option.key}>
            <div
              className={clsx(
                styles.sortOption,
                option.active && styles.active
              )}
              key={option.key}
            >
              <Button
                mode="unset"
                onClick={() => {
                  option.setFunction();
                }}
              >
                {option.display}
              </Button>
              <Checkmark />
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default SortModalContent;
